import ReactDOM from 'react-dom';
import styled from 'styled-components';

interface Props {
  title: string;
  desc?: string;
  grayButtonText?: string;
  blueButtonText: string;
  onGrayClick?: () => void;
  onBlueClick?: () => void;
  onClose: () => void;
}

function ConfirmAlert({
  title,
  desc,
  grayButtonText,
  blueButtonText,
  onGrayClick,
  onBlueClick,
  onClose,
}: Props) {
  const content = (
    <Container
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <Inner onClick={(e) => e.stopPropagation()}>
        <TextContainer>
          <Title>{title}</Title>
          <Description>{desc && desc}</Description>
        </TextContainer>
        <ButtonContainer>
          <Button
            onClick={() => {
              if (onGrayClick) onGrayClick();
              onClose();
            }}
          >
            {grayButtonText ?? '닫기'}
          </Button>
          <ConfirmButton
            onClick={() => {
              if (onBlueClick) onBlueClick();
              onClose();
            }}
          >
            {blueButtonText}
          </ConfirmButton>
        </ButtonContainer>
      </Inner>
    </Container>
  );

  return ReactDOM.createPortal(content, document.body);
}

export default ConfirmAlert;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 328px;
  padding: 24px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 18px;
  color: #222222;
  margin: 0;
  white-space: pre-line;
  text-align: center;
`;

const Description = styled(Title)`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
  white-space: pre-line;
`;
const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Button = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 14px 28px;
  background-color: #70737c14;
  cursor: pointer;
  border: none;

  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #616161;
  white-space: nowrap;
`;

const ConfirmButton = styled(Button)`
  background-color: #008aff;
  color: #ffffff;
`;
